// extracted by mini-css-extract-plugin
export default {"textArea":"personalizedTextArea_textArea__iCGDT","textAreaWrapper":"personalizedTextArea_textAreaWrapper__-ECiR"};